export const paginateItems = (items: Array<any>, perPage: number, page: number) => items.slice(page * perPage - perPage, (page + 1) * perPage - perPage)
